﻿export class Comunicado{
    asunto: string;
    mensaje: string;
    destinatarios: string[];
}